import * as React from "react";

const DeleteIcon = () => (
<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_12367_485)">
<path d="M17.5859 8.707L14.2929 12L17.5859 15.293L16.1719 16.707L12.8789 13.414L9.58591 16.707L8.17191 15.293L11.4649 12L8.17191 8.707L9.58591 7.293L12.8789 10.586L16.1719 7.293L17.5859 8.707ZM24.8789 12C24.8789 18.617 19.4959 24 12.8789 24C6.26191 24 0.878906 18.617 0.878906 12C0.878906 5.383 6.26191 0 12.8789 0C19.4959 0 24.8789 5.383 24.8789 12ZM22.8789 12C22.8789 6.486 18.3929 2 12.8789 2C7.36491 2 2.87891 6.486 2.87891 12C2.87891 17.514 7.36491 22 12.8789 22C18.3929 22 22.8789 17.514 22.8789 12Z" fill="#C8414B"/>
</g>
<defs>
<clipPath id="clip0_12367_485">
<rect width="24" height="24" fill="white" transform="translate(0.878906)"/>
</clipPath>
</defs>
</svg>

);

export default DeleteIcon; 


